<template>
  <div class="wrapper-book wh100p">
    <section class="section-navs df">
      <div class="back-btn _themecolor f-m df-c-ct" @click="$router.go(-1)">
        <img class="arrow" :src="iconArrowLeft">
        <div>{{$t('book.timeSetting')}}</div>
      </div>
    </section>

    <section class="section-form" v-if="bookTimes.length">
      <div class="form _bf" :style="'max-height:'+tableMaxHeight+'px'">
        <div class="row df-c-sb _borderbottom" v-for="(x,i) in bookTimes" :key="i">
          <div class="label f-m _themecolor">{{x.bookDate}}</div>
          <div class="value h100p df-c-fe">
            <el-switch active-color="#34C759" inactive-color="#d0d0d0" v-model="x.openBookTime" @change="submit" />
          </div>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
import mixin_table_simple from '@/mixins/mixin_table_simple'
export default {
  name: 'timeSetting',
  mixins: [mixin_table_simple],
  data() {
    return {
      bookTimes: [],

      otherHeight: 180,
    }
  },
  methods: {
    async submit() {
      const shopConfig = this.shopConfig_m
      shopConfig.bookConfig.bookTimeList = this.bookTimes

      const rD = {
        id: this.currentShopId,
        shopConfig
      }

      const _D = await this.setData('shop', rD)
      // console.log(`%c_R:`, 'color: #00f;', _R)
      if (_D === 'ok') {
        this.$message.success(this.$t('common.handleSuccess'))
      }
    },
  },
  created() {
    this.bookTimes = this.bookConfig_m.bookTimeList
  },
}
</script>

<style lang='scss' scoped>
.section-navs{
  height: 80px;line-height: 80px;background: #fff;padding: 0 10px;
  .back-btn{
    padding: 0 10px;width: auto;height: 80px;white-space: nowrap;font-weight: bold;
    .arrow{width: 24px;height: 24px;margin-right: 12px;}
  }
}
.section-form{
  height: calc(100% - 100px);
  .form{
    width: calc(100% - 40px);margin: 20px 20px;padding: 20px 40px;box-sizing: border-box;border-radius: 12px;
    overflow: hidden scroll;
    .row{height: 56px;}
  }
}
</style>